import { UserWidget, VisibilityUserSettings } from '@/common/constants/online.homepagegateway.api';
import { SearchDisplayWidget as SearchDisplayFragment } from '@chr/online-order-shipment-search-widget';
import { useAppConfig } from "@/common/utilities/UseAppConfig";
import { useDispatch, useSelector } from 'react-redux';
import { AppState } from '@/react-app-env';
import { fetchUserSettingsInit } from '@/common/actions/visibilityUserSettingsActions';
import { useEffect } from 'react';

const LEGACY_CARRIER_BOOKED_KEY = 'Carrier Booked';
const BOOKED_KEY = 'Booked';

export interface OrderShipmentSearchWidgetProps {
  userWidget: UserWidget;
  // config: AppConfig;
}

export const normalizeUserWidgetForSearchDisplay = (userWidget: UserWidget): UserWidget => {
  const statuses = userWidget.dataModelOptions?.statuses;

  if (!statuses?.length) {
    return userWidget;
  }

  const canonicalStatuses = new Map<string, { key: string; active: boolean }>();

  statuses.forEach((status) => {
    const canonicalKey = status.key === LEGACY_CARRIER_BOOKED_KEY ? BOOKED_KEY : status.key;
    const existing = canonicalStatuses.get(canonicalKey);

    if (!existing) {
      canonicalStatuses.set(canonicalKey, { ...status, key: canonicalKey });
      return;
    }

    existing.active = existing.active || status.active;
  });

  return {
    ...userWidget,
    dataModelOptions: {
      ...userWidget.dataModelOptions,
      statuses: Array.from(canonicalStatuses.values()),
    },
  };
};

export const OrderShipmentSearchWidget = ({
  userWidget,
  // config,
}: OrderShipmentSearchWidgetProps) => {
  const config = useAppConfig();
  const dispatch = useDispatch();
  const userSettings: VisibilityUserSettings | null = useSelector(
    (state: AppState) => state.userSettingsState.userSettings
  );
  const isLoading: boolean = useSelector(
    (state: AppState) => state.userSettingsState.isLoading
  );

  useEffect(() => {
    dispatch(fetchUserSettingsInit());
  }, [dispatch]);

  const normalizedUserWidget = normalizeUserWidgetForSearchDisplay(userWidget);

  return <SearchDisplayFragment userWidget={normalizedUserWidget} config={config} userSettings={userSettings} isLoading={isLoading} />;
};

export default OrderShipmentSearchWidget;